(function () {
  var root = document.querySelector('.won');
  if (!root) return;

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function typeUnits(s) {
    if (!s) return [];
    try {
      if (typeof Intl !== 'undefined' && Intl.Segmenter) {
        return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(s), function (
          seg
        ) {
          return seg.segment;
        });
      }
    } catch (e) {}
    return Array.from(s);
  }

  function typeText(target, text, msChar) {
    return new Promise(function (resolve) {
      if (!target) {
        resolve();
        return;
      }
      var units = typeUnits(text);
      if (!units.length) {
        resolve();
        return;
      }
      var i = 0;
      function step() {
        if (i >= units.length) {
          resolve();
          return;
        }
        i += 1;
        target.textContent = units.slice(0, i).join('');
        setTimeout(step, msChar);
      }
      step();
    });
  }

  function deleteText(target, msChar) {
    return new Promise(function (resolve) {
      if (!target) {
        resolve();
        return;
      }
      function step() {
        var t = target.textContent || '';
        if (!t.length) {
          resolve();
          return;
        }
        var units = typeUnits(t);
        units.pop();
        target.textContent = units.join('');
        setTimeout(step, msChar);
      }
      step();
    });
  }

  var rotator = root.querySelector('[data-won-rotator]');
  if (rotator) {
    var slides = Array.prototype.slice
      .call(rotator.querySelectorAll('[data-won-rotate-slide]'))
      .filter(function (el) {
        return !el.hasAttribute('data-won-rotate-skip');
      });
    var holdMs = parseInt(rotator.getAttribute('data-hold-ms') || '2000', 10);
    var typeMschar = parseInt(rotator.getAttribute('data-type-ms') || '70', 10);
    var delMschar = parseInt(rotator.getAttribute('data-delete-ms') || '45', 10);
    if (!isFinite(holdMs) || holdMs < 0) holdMs = 2000;
    if (!isFinite(typeMschar) || typeMschar < 0) typeMschar = 70;
    if (!isFinite(delMschar) || delMschar < 0) delMschar = 45;

    if (slides.length) {
      slides.forEach(function (s) {
        s.classList.remove('is-active');
      });

      function runSlide(idx) {
        var slide = slides[idx];
        var nextIdx = (idx + 1) % slides.length;
        var isType = slide.hasAttribute('data-won-type-slide');
        var target = slide.querySelector('[data-won-type-target]');
        var sourceEl = slide.querySelector('[data-won-type-source]');
        var full =
          (sourceEl && sourceEl.textContent ? sourceEl.textContent.trim() : '') ||
          slide.getAttribute('data-won-type-full') ||
          '';

        function next() {
          runSlide(nextIdx);
        }

        if (isType && target && full.length) {
          target.textContent = '';
          target.classList.add('won__hero-rotator-type-target--cursor');
          slide.classList.add('is-active');
          typeText(target, full, typeMschar)
            .then(function () {
              target.classList.remove('won__hero-rotator-type-target--cursor');
              return sleep(holdMs);
            })
            .then(function () {
              target.classList.add('won__hero-rotator-type-target--cursor');
              return deleteText(target, delMschar);
            })
            .then(function () {
              target.classList.remove('won__hero-rotator-type-target--cursor');
              target.textContent = '';
              slide.classList.remove('is-active');
              next();
            });
          return;
        }

        slide.classList.add('is-active');
        sleep(holdMs).then(function () {
          slide.classList.remove('is-active');
          next();
        });
      }

      runSlide(0);
    }
  }

  var wonPanelTopHandlersBound = false;

  function syncWonPanelTopFromHeader() {
    var fixed =
      document.querySelector('.shopify-section-group-header-group .section-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header.header-wrapper') ||
      document.querySelector('.header-wrapper');
    if (!fixed) return;
    var bottom = fixed.getBoundingClientRect().bottom;
    if (bottom < 1) return;
    var gap =
      typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 989px)').matches
        ? 12
        : 10;
    document.documentElement.style.setProperty('--won-panel-top', Math.ceil(bottom + gap) + 'px');
  }

  function bindWonPanelTopSync() {
    if (wonPanelTopHandlersBound) return;
    wonPanelTopHandlersBound = true;
    function onLayout() {
      if (document.querySelector('.won__panel:not([hidden])')) syncWonPanelTopFromHeader();
    }
    window.addEventListener('resize', onLayout, { passive: true });
    window.addEventListener('orientationchange', onLayout);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onLayout);
      window.visualViewport.addEventListener('scroll', onLayout);
    }
  }

  function openPanel(id) {
    var panel = document.querySelector('[data-won-panel="' + id + '"]');
    if (!panel) return;
    syncWonPanelTopFromHeader();
    bindWonPanelTopSync();
    panel.hidden = false;
    requestAnimationFrame(function () {
      syncWonPanelTopFromHeader();
    });
    document.body.style.overflow = 'hidden';
    var btn = root.querySelector('[data-won-open="' + id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closePanel(id) {
    var panel = document.querySelector('[data-won-panel="' + id + '"]');
    if (!panel) return;
    panel.hidden = true;
    document.body.style.overflow = '';
    var btn = root.querySelector('[data-won-open="' + id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  (function initMapZoomPan() {
    var viewport = root.querySelector('[data-won-map-viewport]');
    var surface = root.querySelector('[data-won-map-surface]');
    if (!viewport || !surface) return;

    var MAX_SCALE = 4;
    var scale = 1;
    var tx = 0;
    var ty = 0;

    var pointers = new Map();
    var panBase = null;
    var lastPinchDist = 0;

    function getMinScale() {
      var vw = viewport.clientWidth;
      var vh = viewport.clientHeight;
      var mw = surface.offsetWidth;
      var mh = surface.offsetHeight;
      if (!mw || !mh || !vw || !vh) return 1;
      return Math.min(1, vw / mw, vh / mh);
    }

    function clampScale(s) {
      return Math.min(MAX_SCALE, Math.max(getMinScale(), s));
    }

    function isZoomedBeyondFit() {
      return scale > getMinScale() + 0.002;
    }

    function clampTransform() {
      scale = clampScale(scale);
      var vw = viewport.clientWidth;
      var vh = viewport.clientHeight;
      var mw = surface.offsetWidth;
      var mh = surface.offsetHeight;
      if (!mw || !mh || !vw || !vh) return;
      var sw = mw * scale;
      var sh = mh * scale;
      var margin = 24;

      if (sw <= vw) {
        tx = (vw - sw) / 2;
      } else {
        tx = Math.min(margin, Math.max(vw - sw - margin, tx));
      }
      if (sh <= vh) {
        ty = (vh - sh) / 2;
      } else {
        ty = Math.min(margin, Math.max(vh - sh - margin, ty));
      }
    }

    function applyTransform() {
      surface.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
      viewport.style.setProperty('--won-map-scale', String(scale));
      viewport.classList.toggle('won__map-viewport--zoomed', isZoomedBeyondFit());
      updateScaleLegend();
    }

    function fitZoomedOut() {
      scale = getMinScale();
      tx = 0;
      ty = 0;
      clampTransform();
      applyTransform();
    }

    function zoomAtViewportPoint(cx, cy, nextScale) {
      var ns = clampScale(nextScale);
      var wx = (cx - tx) / scale;
      var wy = (cy - ty) / scale;
      tx = cx - wx * ns;
      ty = cy - wy * ns;
      scale = ns;
      clampTransform();
      applyTransform();
    }

    function dist(a, b) {
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getTwoPinchPoints() {
      var ids = Array.from(pointers.keys());
      if (ids.length < 2) return null;
      var p0 = pointers.get(ids[0]);
      var p1 = pointers.get(ids[1]);
      return { p0: p0, p1: p1 };
    }

    var scaleLegend = viewport.querySelector('[data-won-map-scale]');
    var scaleBarEl = scaleLegend ? scaleLegend.querySelector('[data-won-map-scale-bar]') : null;
    var scaleLabelEl = scaleLegend ? scaleLegend.querySelector('[data-won-map-scale-label]') : null;
    var scaleSublabelEl = scaleLegend ? scaleLegend.querySelector('[data-won-map-scale-sublabel]') : null;

    var KM_PER_MI = 1.609344;
    var MI_PER_KM = 0.621371;

    function isMilesRefUnit(unit) {
      var s = (unit || '').toLowerCase().trim();
      return s === 'mi' || s === 'mile' || s === 'miles';
    }

    function formatScaleNumberString(m) {
      var rounded;
      if (m >= 100) rounded = Math.round(m);
      else if (m >= 10) rounded = Math.round(m * 10) / 10;
      else if (m >= 1) rounded = Math.round(m * 100) / 100;
      else rounded = Math.round(m * 1000) / 1000;
      if (rounded % 1 === 0) {
        var ri = Math.round(rounded);
        return typeof ri.toLocaleString === 'function' ? ri.toLocaleString() : String(ri);
      }
      return String(rounded);
    }

    function appendScalePart(container, numText, suffixText) {
      var n = document.createElement('span');
      n.className = 'won__map-scale__num';
      n.textContent = numText;
      container.appendChild(n);
      var u = document.createElement('span');
      u.className = 'won__map-scale__suffix';
      u.textContent = suffixText;
      container.appendChild(u);
    }

    function parseScaleRefAttr(attr) {
      if (attr === null || attr === undefined || attr === '') return 0;
      var s = String(attr)
        .trim()
        .replace(/,/g, '')
        .replace(/\s+/g, '');
      var n = parseFloat(s, 10);
      return isFinite(n) ? n : 0;
    }

    /** Layout px width of the map graphic (object-fit: contain), same space as ref distance. */
    function getMapGeographyWidthPx() {
      var mapEl = surface.querySelector('[data-won-map]');
      var img = surface.querySelector('.won__map-outline');
      if (!mapEl || !mapEl.offsetWidth || !mapEl.offsetHeight) {
        return Math.max(1, surface.offsetWidth || 1);
      }
      var boxW = mapEl.clientWidth || mapEl.offsetWidth;
      var boxH = mapEl.clientHeight || mapEl.offsetHeight;
      if (
        !img ||
        !img.naturalWidth ||
        !img.naturalHeight ||
        img.naturalWidth < 2 ||
        img.naturalHeight < 2
      ) {
        return Math.max(1, boxW);
      }
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      var fit = Math.min(boxW / nw, boxH / nh);
      return Math.max(1, nw * fit);
    }

    function updateScaleLegend() {
      if (!scaleLegend || !scaleBarEl || !scaleLabelEl) return;
      var W = getMapGeographyWidthPx();
      if (!W) return;
      var refD = parseScaleRefAttr(viewport.getAttribute('data-won-map-scale-ref'));
      var fineRaw = parseScaleRefAttr(viewport.getAttribute('data-won-map-scale-fine'));
      var finePct = fineRaw > 0 && isFinite(fineRaw) ? fineRaw : 100;
      finePct = Math.min(400, Math.max(50, finePct));
      var unit = viewport.getAttribute('data-won-map-scale-unit') || 'km';
      var minS = getMinScale();
      if (scaleSublabelEl) scaleSublabelEl.textContent = '';
      scaleLabelEl.textContent = '';
      scaleLabelEl.className = 'won__map-scale__label';

      if (refD > 0 && isFinite(refD)) {
        scaleLegend.classList.remove('won__map-scale--zoom-only');
        scaleBarEl.style.removeProperty('width');
        var L = scaleBarEl.offsetWidth;
        if (!L) L = 88;
        var M = (L * refD * (finePct / 100)) / (W * scale);
        if (!isFinite(M) || M < 0) M = 0;
        var km = isMilesRefUnit(unit) ? M * KM_PER_MI : M;
        var mi = isMilesRefUnit(unit) ? M : M * MI_PER_KM;
        var kmStr = formatScaleNumberString(km);
        var miStr = formatScaleNumberString(mi);
        scaleLabelEl.classList.add('won__map-scale__label--dual');
        appendScalePart(scaleLabelEl, miStr, 'mi');
        var sep = document.createElement('span');
        sep.className = 'won__map-scale__sep';
        sep.textContent = '\u00a0·\u00a0';
        scaleLabelEl.appendChild(sep);
        appendScalePart(scaleLabelEl, kmStr, 'km');
        var aria =
          'Graphic scale: about ' +
          miStr +
          ' miles or ' +
          kmStr +
          ' kilometers across the bar; each half is half that distance';
        scaleLegend.setAttribute('aria-label', aria);
      } else {
        scaleLegend.classList.add('won__map-scale--zoom-only');
        scaleBarEl.style.removeProperty('width');
        var z = minS > 0 ? scale / minS : 1;
        if (!isFinite(z) || z < 0.1) z = 1;
        var zStr = z < 10 ? String(Math.round(z * 10) / 10).replace(/\.0$/, '') : String(Math.round(z));
        scaleLabelEl.classList.add('won__map-scale__label--zoom');
        var zn = document.createElement('span');
        zn.className = 'won__map-scale__num';
        zn.textContent = zStr;
        scaleLabelEl.appendChild(zn);
        var zs = document.createElement('span');
        zs.className = 'won__map-scale__suffix';
        zs.textContent = '\u00d7 zoom';
        scaleLabelEl.appendChild(zs);
        scaleLegend.setAttribute('aria-label', 'Map zoom ' + zStr + ' times the overview');
        if (scaleSublabelEl) {
          scaleSublabelEl.textContent = 'Set map width distance for scale';
        }
      }
    }

    viewport.addEventListener(
      'wheel',
      function (e) {
        if (!(e.ctrlKey || e.metaKey)) {
          if (!isZoomedBeyondFit()) return;
          tx -= e.deltaX;
          ty -= e.deltaY;
          clampTransform();
          applyTransform();
          e.preventDefault();
          return;
        }
        e.preventDefault();
        var rect = viewport.getBoundingClientRect();
        var cx = e.clientX - rect.left;
        var cy = e.clientY - rect.top;
        var factor = e.deltaY < 0 ? 1.07 : 1 / 1.07;
        zoomAtViewportPoint(cx, cy, scale * factor);
      },
      { passive: false }
    );

    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target.closest('.won__map-point')) return;

      try {
        viewport.focus({ preventScroll: true });
      } catch (err) {
        viewport.focus();
      }
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size === 2) {
        panBase = null;
        var pair = getTwoPinchPoints();
        if (pair) lastPinchDist = dist(pair.p0, pair.p1);
        pointers.forEach(function (_, pid) {
          try {
            viewport.setPointerCapture(pid);
          } catch (err2) {}
        });
      } else if (pointers.size === 1) {
        lastPinchDist = 0;
        if (isZoomedBeyondFit()) {
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (err) {}
          panBase = { tx: tx, ty: ty, x: e.clientX, y: e.clientY };
        } else {
          panBase = null;
        }
      }
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size >= 2) {
        var pair = getTwoPinchPoints();
        if (!pair) return;
        var d = dist(pair.p0, pair.p1);
        var rect = viewport.getBoundingClientRect();
        var cx = (pair.p0.x + pair.p1.x) / 2 - rect.left;
        var cy = (pair.p0.y + pair.p1.y) / 2 - rect.top;
        if (lastPinchDist > 0) {
          var ratio = d / lastPinchDist;
          zoomAtViewportPoint(cx, cy, scale * ratio);
        }
        lastPinchDist = d;
        return;
      }

      if (pointers.size === 1 && panBase) {
        tx = panBase.tx + (e.clientX - panBase.x);
        ty = panBase.ty + (e.clientY - panBase.y);
        clampTransform();
        applyTransform();
        panBase = { tx: tx, ty: ty, x: e.clientX, y: e.clientY };
      }
    });

    function endPointer(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      try {
        viewport.releasePointerCapture(e.pointerId);
      } catch (err) {}
      lastPinchDist = 0;
      if (pointers.size === 1) {
        var ids = Array.from(pointers.keys());
        var pid = ids[0];
        var left = pointers.get(pid);
        if (left) {
          if (isZoomedBeyondFit()) {
            try {
              viewport.setPointerCapture(pid);
            } catch (err2) {}
            panBase = { tx: tx, ty: ty, x: left.x, y: left.y };
          } else {
            panBase = null;
            try {
              viewport.releasePointerCapture(pid);
            } catch (err3) {}
          }
        }
      } else {
        panBase = null;
      }
    }

    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);

    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        if (!isZoomedBeyondFit()) return;
        tx += 40;
        clampTransform();
        applyTransform();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        if (!isZoomedBeyondFit()) return;
        tx -= 40;
        clampTransform();
        applyTransform();
        e.preventDefault();
      } else if (e.key === 'ArrowUp') {
        if (!isZoomedBeyondFit()) return;
        ty += 40;
        clampTransform();
        applyTransform();
        e.preventDefault();
      } else if (e.key === 'ArrowDown') {
        if (!isZoomedBeyondFit()) return;
        ty -= 40;
        clampTransform();
        applyTransform();
        e.preventDefault();
      } else if (e.key === '+' || e.key === '=') {
        var r = viewport.getBoundingClientRect();
        zoomAtViewportPoint(r.width / 2, r.height / 2, scale * 1.15);
        e.preventDefault();
      } else if (e.key === '-' || e.key === '_') {
        var r2 = viewport.getBoundingClientRect();
        zoomAtViewportPoint(r2.width / 2, r2.height / 2, scale / 1.15);
        e.preventDefault();
      }
    });

    function onViewportResize() {
      var ms = getMinScale();
      if (scale < ms) scale = ms;
      clampTransform();
      applyTransform();
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onViewportResize);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', onViewportResize, { passive: true });
    }

    fitZoomedOut();
    requestAnimationFrame(fitZoomedOut);

    var mapImg = surface.querySelector('.won__map-outline');
    if (mapImg && !mapImg.complete) {
      mapImg.addEventListener('load', fitZoomedOut);
    }
  })();

  root.querySelectorAll('[data-won-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openPanel(btn.getAttribute('data-won-open'));
    });
  });

  document.querySelectorAll('.won__panel [data-won-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closePanel(el.getAttribute('data-won-close'));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.won__panel:not([hidden])').forEach(function (panel) {
      var id = panel.getAttribute('data-won-panel');
      if (id) closePanel(id);
    });
  });

  var speakBtn = root.querySelector('[data-won-speak]');
  if (speakBtn && 'speechSynthesis' in window) {
    speakBtn.addEventListener('click', function () {
      var text = (speakBtn.getAttribute('data-speak-text') || '').trim();
      if (!text) return;
      window.speechSynthesis.cancel();
      var u = new SpeechSynthesisUtterance(text);
      u.lang = 'en-US';
      u.rate = 0.92;
      window.speechSynthesis.speak(u);
    });
  } else if (speakBtn) {
    speakBtn.hidden = true;
    speakBtn.setAttribute('aria-hidden', 'true');
  }
})();
